import { useEffect } from 'react';
import { initGA4, initGoogleAds, initMetaPixel, initGoogleTagManager } from '../utils/analytics';

// Hook para inicializar rastreamento de anúncios e analytics
const useAdTracking = () => {
  useEffect(() => {
    const initializeTracking = () => {
      try {
        // Google Analytics 4
        initGA4();

        // Google Ads
        initGoogleAds();

        // Meta Pixel (Facebook/Instagram)
        initMetaPixel();

        // Google Tag Manager (opcional)
        initGoogleTagManager();

        console.log('🎯 Ad tracking initialized successfully');
      } catch (error) {
        console.error('❌ Error initializing ad tracking:', error);
      }
    };

    if (document.readyState === 'complete') {
      initializeTracking();
    } else {
      window.addEventListener('load', initializeTracking);
      return () => window.removeEventListener('load', initializeTracking);
    }
  }, []);
};

export default useAdTracking;
